<template>
	<div class="fixwidth">
		<!--个人信息开始-->
		<div class="info-box">
			<div class="photo fl">
				<img src="../../../static/img/photo.jpeg" v-if="userInfo.avatar===null">
				<img v-else v-lazy="serverIp+userInfo.avatar" alt="photo">
			</div>
			<div class="info fr">
				<div class="top-line">{{userInfo.userName}}</div>
				<div class="bottom-line">
					<label>手机号:</label><span>{{userInfo.phoneNumber}}</span>
					<label>邮箱:</label><span>{{userInfo.email}}</span>
					<span v-if="$store.getters.getToken.company!==null">
						<label>单位名称:</label><span>{{userInfo.companyName}}</span>
						<label>部门名称:</label><span>{{userInfo.departmentName}}</span>
						<label>岗位名称:</label><span>{{userInfo.positionName}}</span>
					</span>
					<br>
					<button @click="edit" style="right:200px;" class="edit"><i class="el-icon-document"></i>编辑资料</button>
					<button @click="openPwd" class="edit"><i class="el-icon-document"></i>修改密码</button>
				</div>
			</div>
		</div>
		<!--个人信息结束-->
		
		
		<el-dialog  class="elDialog abow_dialog" :close-on-click-modal="false" title="修改信息" :visible.sync="editVisible">
			<el-form class="form" ref="editInfo" :model="editInfo" label-width="80px">
				<el-form-item label="用户名">
					<el-input v-model="editInfo.userName"></el-input>
				</el-form-item>
				<el-form-item label="邮箱">
					<el-input v-model="editInfo.email"></el-input>
				</el-form-item>
				<el-form-item label="编辑头像">
					<el-upload
							ref="upload"
							class="upload"
							style="text-align: left;"
							action=""
							:auto-upload=false
							:file-list="imgList"
							:show-file-list=false
							:on-change="handleChange">
						<div class="btn">
							<el-button>上传本地图片</el-button>
						</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="">
					<img v-if="editInfo.avatar!==null&&editPic" v-lazy="serverIp+editInfo.avatar" style="width:120px;height:120px;">
				</el-form-item>
				<el-button type="primary" @click="editUser">确认发布</el-button>
				<el-button type="primary" @click="editVisible = false">取消</el-button>
			</el-form>
		</el-dialog>
		
		
		<el-dialog  class="elDialog abow_dialog" :close-on-click-modal="false" title="修改密码" :visible.sync="pwdVisible">
			<el-form :rules="formRules" :validate-on-rule-change="false" class="form" ref="editPassword" :model="editPassword" label-width="80px">
				<el-form-item label="原密码" prop="credentials">
					<el-input type="password" v-model="editPassword.credentials"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input type="password" v-model="editPassword.newPwd"></el-input>
				</el-form-item>
				<el-form-item label="重复输入" prop="newPwd2">
					<el-input type="password" v-model="editPassword.newPwd2"></el-input>
				</el-form-item>
				<el-button type="primary" @click="editPwd">确认发布</el-button>
				<el-button type="primary" @click="pwdVisible = false">取消</el-button>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
    export default {
        name: "PersonalInfo",
        data(){
            let validatePassword2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请确认密码'));
                } else if (value !== this.editPassword.newPwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return{
                userInfo:{},
                editInfo:{},            //修改
                editVisible:false,
                imgList:[],
                editPic:false,
                editPassword:{
                    credentials:"",
                    newPwd:"",
                    newPwd2:""
                },
                pwdVisible:false,
                formRules: {
                    'credentials': [
                        {message: '请输入原密码',required: true,trigger:'blur'},
                    ],
                    'newPwd': [
                        {message: '请输入新密码',required: true,trigger:'blur'},
                    ],
                    'newPwd2': [
                        {validator:validatePassword2,required: true,trigger:'blur'},
                    ],
                }
            }
        },
        created() {
            this.getUserInfo();
        },
        methods:{
            edit(){
                this.editVisible = true;
                this.editInfo = JSON.parse(JSON.stringify(this.userInfo));
            },
            openPwd(){
                if(this.$refs.editPassword!==undefined){
                    this.$refs.editPassword.resetFields();
                }
                this.editPassword={
                    credentials:"",
                    newPwd:"",
                };
                this.pwdVisible = true;
            },
            editPwd(){
                let data = JSON.parse(JSON.stringify(this.editPassword));
                delete data.newPwd2;
                data.id=this.$store.getters.getToken.userId;
                this.$refs.editPassword.validate((valid) => {
                    if(valid){
                        this.$json("/user/updatePwd","POST",data).then(()=>{
                            this.$message.success("修改成功");
                            this.pwdVisible=false;
                        });
                    }
                });
            },
            editUser(){
                this.editInfo.id = this.$store.getters.getToken.id;
                this.$put("/user",this.editInfo).then(()=>{
                    this.userInfo = this.editInfo;
                    this.editVisible = false;
                })
            },
            getUserInfo(){
                this.$json("/user/"+this.$store.getters.getToken.id,"GET",{}).then((res)=>{
                    this.userInfo=res.data;
                });
            },
            handleChange(file,fileList){
                this.editPic=true;
                let upload = new FormData;
                upload.append("file",file.raw);
                let config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                this.$upload("/resource/upload",upload,config).then((res)=> {
                    this.editInfo.avatar = res.data;
                });
            }
        }
    }
</script>

<style scoped lang="less">
	.info-box {
		background-color: #f9f9f9;
		height: 115px;
		margin-top: 40px;
		padding: 20px;
		/*>div{
			display: flex;
			align-items: center;
		}*/
		
		.photo img{
			height: 120px;
			width: 120px;
		}
		
		.info {
			width: 1100px;
			height: 120px;
			background-color: #fff;
			
			div {
				text-align: left;
				padding-left: 20px;
			}
		}
		
		.top-line {
			height: 50px;
			line-height: 50px;
			border-bottom: 1px solid #f9f9f9;
		}
		
		.bottom-line {
			height: 69px;
			font-size: 14px;
			line-height: 30px;
			position: relative;
			
			span {
				padding-right: 30px;
			}
		}
	}
	button.edit {
		width: 150px;
		height: 50px;
		border: 1px solid #cccccc;
		outline: none;
		background-color: #fff;
		font-size: 18px;
		color: #666666;
		cursor: pointer;
		position: absolute;
		top: 10px;
		right: 20px;
	}
	
	button.edit:active {
		position: absolute;
		top: 11px;
		right: 19px;
	}

</style>
